/**
 * Trailing “Add column” control — sits after the last column like Trello’s
 * “Add another list”. Opens the same add flow as insert zones (consumer dialog).
 */

import type { ReactNode } from 'react';
import { Plus } from 'lucide-react';
import { cn } from '@/utils/cn';
import { kanbanTrailingAddColumnClass } from './Kanban.styles';

export interface KanbanTrailingAddColumnProps {
  label?: ReactNode;
  disabled?: boolean;
  onAdd: () => void;
  className?: string;
}

export function KanbanTrailingAddColumn({
  label = 'Add column',
  disabled = false,
  onAdd,
  className,
}: KanbanTrailingAddColumnProps) {
  return (
    <button
      type="button"
      disabled={disabled}
      aria-label={typeof label === 'string' ? label : 'Add column'}
      className={cn(kanbanTrailingAddColumnClass, className)}
      onClick={onAdd}
    >
      <Plus className="h-4 w-4 shrink-0" strokeWidth={2} aria-hidden />
      <span className="truncate text-sm font-medium">{label}</span>
    </button>
  );
}
